import regions from '../../config/riot_regions';
import i18n from '../i18n';

const serviceUrl = process.env.SERVICE_URL;
const parseJson = response => response.json();

const checkStatus = (response) => {
  if(response.status >= 200 && response.status < 300) {
    return response;
  } else {
    return parseJson(response).then(json => {
      let e = new Error(json.status.message);
      e.response = response;

      throw e;
    });
  }
}

const qs = (params) => {
  const esc = encodeURIComponent;

  return Object.keys(params)
             .map((k) => {
               if (params[k] instanceof Array) {
                 return params[k].map(p => esc(k) + '=' + esc(p)).join('&')
               } else {
                 return esc(k) + '=' + esc(params[k])
               }
             })
             .join('&')
}

export const fetchPlayer = (shard) => {
  console.log("API Call: fetchPlayer(): " + regions.shardPlatform(shard));

  const params = {
    shard_id: regions.shardPlatform(shard),
    lang: i18n.currentLanguage(),
    window: [30, 7, 2]
  };

  return fetch(`${serviceUrl}/player?${qs(params)}`, { credentials: 'include' }).then(checkStatus).then(parseJson);
}

export const fetchAnonymous = (shard) => {
  console.log("API Call: fetchAnonymous(): " + regions.shardPlatform(shard));

  const params = {
    shard_id: regions.shardPlatform(shard),
    lang: i18n.currentLanguage(),
    window: [30, 7, 2]
  };

  return fetch(`${serviceUrl}/whereami?${qs(params)}`, { credentials: 'include' }).then(checkStatus).then(parseJson);
}

export const locationSearch = ({ city, region, country, local_city, local_region, point, shard }) => {
  const params = {
    city: city.toLowerCase(),
    region: region.toLowerCase(),
    country: country.toLowerCase(),
    local_city: local_city.toLowerCase(),
    local_region: local_region.toLowerCase(),
    latitude: point.lat,
    longitude: point.lng,
    lang: i18n.currentLanguage(),
    shard_id: regions.shardPlatform(shard)
  };

  return fetch(`${serviceUrl}/cities?${qs(params)}`, { credentials: 'include' }).then(checkStatus).then(parseJson);
}

export const fetchLocation = (location_id, shard) => {
  console.log(`API Call loadLocation: location_id: ${location_id} platform: ${regions.shardPlatform(shard)}`);

  const params = {
    location_id,
    shard_id: regions.shardPlatform(shard),
    lang: i18n.currentLanguage(),
    window: [30, 7, 2]
  };

  return fetch(`${serviceUrl}/location?${qs(params)}`, { credentials: 'include' }).then(checkStatus).then(parseJson);
}

export const fetchTimeseries = (location_id, isp, shard) => {
  console.log(`API Call loadTimeseries: location_id: ${location_id} isp: ${isp} platform: ${regions.shardPlatform(shard)}`)

  const params = {
    location_id,
    isp,
    shard_id: regions.shardPlatform(shard),
    lang: i18n.currentLanguage(),
    window: 30
  }

  return fetch(`${serviceUrl}/timeseries?${qs(params)}`, { credentials: 'include' }).then(checkStatus).then(parseJson)
}

export const geocode = (address) => {
  console.log(`API Call loadGeocode: address: ${address}`);

  const params = {
    address,
    language: i18n.currentLanguage()
  };

  return fetch(`${serviceUrl}/geocode?${qs(params)}`).then(checkStatus).then(parseJson)
}

export const fetchShards = () => {
  console.log('API Call loadShards()');

  //Data coming from the API has platform_id in the shard attr, so map
  //across to regions, as this app uses regions internally.
  return fetch(`${serviceUrl}/shards`, { credentials: 'include' }).then(checkStatus).then(parseJson).then((data) => {
    return data.map(row => {
      return { ...row, shard: regions.platformShard(row.shard) };
    }).filter(row => process.env.ENABLED_SHARDS.split(',').indexOf(row.shard) > -1);
  });
}

export const putFeedback = (feedback) => {
  feedback.shard = regions.shardPlatform(feedback.shard);

  return fetch(`${serviceUrl}/whereami`,
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: "POST",
      credentials: 'include',
      body: JSON.stringify(feedback)
    }
  ); //.then(checkStatus);
}

export const storeIp = (shard) => {
  return fetch(`${serviceUrl}/storeip`,
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: "POST",
      credentials: 'include',
      body: JSON.stringify({shard: shard})
    }
  );
}



// WEBPACK FOOTER //
// ./src/api/index.js